export const getHistoryQrTableColumns = () => {
	return [
		{
			title: "Dibuat Oleh",
			key: "created_by",
			isSortable: false
		},
		{
			title: "Tanggal Pembuatan",
			key: "created_date",
			isSortable: true
		},
		{
			title: "Qty Qr",
			key: "total_qr_generated",
			isSortable: false
		},
		{
			title: "Qty Scan Spm",
			key: "total_spm_scanned",
			isSortable: false
		},
		{
			title: "QTY SCAN RETAILER",
			key: "total_qr_r2_scanned",
			isSortable: false
		},
	];
}
